
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import EncashmentProcess from "@/components/encashment/EncashmentProcess.vue";
import EncashmentHistory from "@/components/encashment/EncashmentHistory.vue";

export default defineComponent({
  name: "encashment",
  components: {
    EncashmentProcess,
    EncashmentHistory,
  },
  data() {
    return {
      availablebalance: 0.0,
      currency: "",
      fname: "",
      lname: "",
      usid: "",
    };
  },
  computed: {
    maskedUsid(): string {
      const id = String(this.usid || "");
      if (id.length <= 4) {
        return "•••• " + id;
      }
      return "•••• •••• •••• " + id.slice(-4);
    },
    cardHolder(): string {
      const name = `${this.fname || ""} ${this.lname || ""}`.trim();
      return name || String(this.usid || "");
    },
  },
  methods: {
    onProcessLoaded(payload: any) {
      if (!payload) return;
      this.availablebalance = payload.availablebalance;
      this.currency = payload.currency;
      this.fname = payload.fname;
      this.lname = payload.lname;
      this.usid = payload.usid;
    },
  },
  setup() {
    onMounted(() => {
      setCurrentPageTitle("Encashment");
    });
  },
});
